import React from "ES/lib/react";
var _ = require("ES/lib/lodash");
var dd = require("ES/lib/dd");
var radio = require("ES/lib/radio");
var esUtils = require("ES/utils/esUtils");
var ImageURLs = require("../../../utils/ImageURLs");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
var ErrorAlert = require("ES/widgets/ErrorAlert");
var LoadingWrap = require("ES/widgets/LoadingWrap");
var VerticalScroll = require("ES/widgets/VerticalScroll");
var needsToSignMPAgreementFirst = require("./needsToSignMPAgreementFirst");
var isLoading = require("./isLoading");

var EventTabs = require("./EventTabs");
var EventHeader = require("./EventHeader");
var ImportEvent = require("./ImportEvent");
let AuthedUserSession = require("../../../utils/AuthedUserSession");
var NewEventForm = !AuthedUserSession.is_privatelabel
  ? require("./NewEventForm_simple")
  : require("./NewEventForm");

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {
      last_URL_event_id: null, //to detect when to load an event from the server
      event: {},
      saving: false,
      change_company: false,
      error_msg: null,
      info_msg: null,
      last_used_tab: "", //remember what tab the user was looking at and keep it when switching events
    };
  },
  Radio_setup() {
    var self = this;
    var isMe = function (event_id, is_new) {
      return (
        self.__getURL_event_id() == event_id ||
        (is_new && "new" == self.props.url_args[1])
      );
    };
    return {
      load_Event_waiting_on_server: function (event_id) {
        if (isMe(event_id)) {
          this.setState({
            event: {},
            error_msg: null,
            info_msg: null,
            saving: false,
          });
        }
      },
      Event: function (event) {
        if (isMe(event.eid)) {
          this.setState({ event: event, error_msg: null, saving: false });
        }
        if (
          _.get(event, ["companyID"]) !==
            _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]) &&
          this.state.change_company
        ) {
          AuthedUserSession.setLastSelectedCompany(_.get(event, ["companyID"]));
          window.location.reload();
        }

        //when linking from other apps (like SalesRelay) open direct to calendar if the URL looks like
        //   /myevents/#/events/818709/view_year
        if (window.location.hash.includes("view_year")) {
          radio("Show_Calendar").broadcast("year", _.get(event, "starttime"));
          radio("Calendar_setSID").broadcast(_.first(_.get(event, "sids", [])));
        }
      },
      load_Event_failed: function (event_id, message) {
        if (isMe(event_id)) {
          this.setState({
            error_msg: "Failed to load event: " + message,
            saving: false,
            info_msg: null,
          });
        }
      },
      Event_destroyed: function (event_id, message) {
        if (isMe(event_id)) {
          var self = this;
          this.setState(
            {
              info_msg: null,
              error_msg: "Deleted: " + message,
              event: {},
              saving: false,
            },
            function () {
              setTimeout(function () {
                self.setState({ error_msg: null });
                radio("Hashbang_set").broadcast("");
              }, 3000);
            }
          );
        }
      },
      save_Event: function (event) {
        if (isMe(event.eid)) {
          radio("stop_EventPoller").broadcast();
          this.setState({ saving: true, error_msg: null, info_msg: null });
        }
      },
      save_Event_succeeded: function (event, is_new, displaymessage) {
        if (isMe(event.eid, is_new)) {
          radio("start_EventPoller").broadcast(event.eid);
          this.setState({
            saving: false,
            error_msg: null,
            info_msg: displaymessage,
          });
          if (is_new) {
            radio("Hashbang_set").broadcast("/events/" + event.eid);
            radio("event_schedule_change").broadcast(event);
            let self = this;
            if (!_.isEmpty(displaymessage))
              setTimeout(function () {
                self.setState({ info_msg: displaymessage });
              }, 1500); //sloppy, but the Hashbang_set resets our state, losing displaymessage
          }
        }
      },
      save_Event_failed: function (event, message, is_new) {
        if (isMe(event.eid, is_new)) {
          this.setState({
            saving: false,
            error_msg: "Failed to save changes: " + message,
          });
          radio("start_EventPoller").broadcast(event.eid);
        }
      },
    };
  },
  componentDidMount: function () {
    this.__watchURLchange(this.props);
  },
  componentWillReceiveProps: function (props) {
    this.__watchURLchange(props);
  },
  componentWillUnmount: function () {
    radio("stop_EventPoller").broadcast();
  },
  __watchURLchange: function (props) {
    var eid = this.__getURL_event_id(props);
    var selected_tab = this.props.url_args[2];
    if (selected_tab === "load") {
      // if we are loading the event, then change companies, load the event, and default to the details tab
      this.setState({ change_company: true });
      window.location.href = "#/events/" + eid + "/details";
    }

    if (eid > 0) {
      if (eid !== this.state.last_URL_event_id) {
        this.setState(
          {
            last_URL_event_id: eid,
            last_used_tab: selected_tab || this.state.last_used_tab,
          },
          function () {
            setTimeout(function () {
              radio("reload_Event").broadcast(eid); //reload b/c we want to load in the fresh changes rather than being fast by just loading from cache
              radio("start_EventPoller").broadcast(eid);
            }, 16); //wait til after it's all setup before we broadcast
          }
        );
      }
    } else if (
      this.state.last_URL_event_id > 0 ||
      !_.isEmpty(this.state.event)
    ) {
      this.setState({ last_URL_event_id: null, event: {} });
    }
  },
  __getURL_event_id: function (props) {
    props = props || this.props;
    var url_args = props.url_args;
    return esUtils.toInt(url_args[1]);
  },
  render: function () {
    var event = this.state.event;
    var saving = this.state.saving;
    var error_msg = this.state.error_msg;
    var Displaylists = this.props.Displaylists;

    var url_args = this.props.url_args;
    var route = _.first(url_args);
    var selected_tab = url_args[2] || this.state.last_used_tab; //if we didn't get a tab on the url, show the last-used tab

    if (route == "events" && url_args[1] === "import") {
      return ImportEvent({
        Displaylists: Displaylists,
        service_to_import_from: url_args[2],
      });
    }
    if (needsToSignMPAgreementFirst(event, Displaylists)) {
      setTimeout(function () {
        //must run this after the render has finished or it will mess up React's rendering step and cause an error
        radio("Hashbang_set").broadcast("/marketplace/" + _.first(event.sids));
      }, 1);
      return dd.div();
    }

    var show_new_event_form = route == "events" && url_args[1] === "new";
    if (!show_new_event_form && this.__getURL_event_id() < 1) {
      return dd.div(
        { key: _.uniqueId(), style: { height: "100%" } }, //both these keys fix the multiple reactids issues
        VerticalScroll(
          null,
          dd.img({ key: _.uniqueId(), src: ImageURLs.event_placeholder })
        )
      );
    }

    let InfoAlert =
      show_new_event_form || _.isEmpty(this.state.info_msg) ? null : (
        <div className="alert alert-warning">{this.state.info_msg}</div>
      );

    return VerticalScroll(
      null,
      ErrorAlert({ message: error_msg }),
      InfoAlert,
      LoadingWrap(
        {
          is_loading: isLoading(
            event,
            Displaylists,
            show_new_event_form,
            error_msg,
            saving
          ),
          glass:
            !_.isEmpty(Displaylists) &&
            (show_new_event_form || !_.isEmpty(event)),
        },
        show_new_event_form
          ? NewEventForm({
              Displaylists: Displaylists,
              url_params: _.drop(url_args, 2),
            })
          : _.isEmpty(event)
          ? null //only render this if we have the stuff, otherwise it'll throw up and _.isEmpty(event.sids) will be true and try and show the error message
          : dd.div(
              null,
              EventHeader({ event: event, Displaylists: Displaylists }),
              _.isEmpty(event.sids)
                ? ErrorAlert({ message: "no sids attached to this event" })
                : EventTabs({
                    event: event,
                    Displaylists: Displaylists,
                    selected_tab: selected_tab,
                    url_args: url_args,
                  })
            )
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/index.js